import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-ipage-configurator',
	templateUrl:'./IPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./IPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class IPageConfiguratorPluginCompPage
{
	mdContent_983 = `\`\`\`java
import com.jwebmp.client.IPageConfigurator;
\`\`\``;
	mdContent_984 = `\`\`\`java
public class MyConfigurator implements IPageConfigurator&lt;MyConfigurator&gt; {
    @Override
    public IPage&lt;?&gt; configure(IPage&lt;?&gt; page) {
        page.getBody().addCssReference(new CSSReference("custom", "custom.css"));
        return page;
    }
    @Override
    public Integer sortOrder() { return 100; }
}
\`\`\``;
}
